// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uYbUv","info":"nYNVh","subtitle":"dd-x-"};